import { PAGE_MODE } from "../../../constants/constants";
import { BasePage } from "../../../framework/pages/BasePage";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../framework/form/FormFw";

class DatosServisiosModal extends BasePage {
  renderPage(pageApi) {

    const getform_datos_servicio = () => pageApi.getComponent('form_datos_servicio');

    const form_datos_servicio = {
      layout: 'vertical',
      load: {
        queryId: 354,
        params: { ID_CADENA: pageApi.getParamId() },
      },
      save: {
        queryId: 950,
      },
      title: '',
      collapsible: true,
      fields: [
        {
          label: '  ',
          fields: [
            { type: 'hidden', name: 'id_doc' },
            { name: "tipo_producto", label: "Tipo Producto", column: 2, readOnly: true },
            { name: "tipo_cadena", label: "Tipo Cadena", column: 3, readOnly: true },
            { name: "raz_soc", label: "Razon Social", column: 3, readOnly: true },
            { name: "dir_nom", label: "Direccion", column: 3, readOnly: true },
            {
              type: "select",
              name: "id_solicitante",
              label: "Contacto",
              column: 4,
              load: { queryId: 344 },
              search: true,
              readOnly: true,
            },
            { name: "nom_corr", label: "Correo", column: 3, readOnly: true },
            { name: "tel_nro", label: "Telefono", column: 2, readOnly: true },
            { name: "servicio", label: "Tipo Servicio", column: 2, readOnly: true },
            {
              type: "select",
              name: "FRECUENCIA",
              label: "Frecuencia",
              column: 2,
              search: true,
              load: { queryId: 342 },
              allowClear: true,
            },
          ]
        }
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW)
          formApi.load();
      }
    }

    const barButtonFooterdatos_servicio = {
      fields: [
        {
          ...BUTTON_DEFAULT.RETURN, label: 'Retornar Inicio', onClick: () => {
            const pathBack = this.props?.history?.location?.state?.from 
              || `/solicitudes-asignadas/solicitudes-asignadas/${pageApi.name.id_ss}`;
            this.props.history.push(pathBack);
          }
        },
        {
          ...BUTTON_DEFAULT.SAVE, label: 'Guardar', onClick: async () => {
            getform_datos_servicio().save({ params: {
              ...getform_datos_servicio().getData(),
              ID_CADENA: pageApi.getParamId()
            } });
          },
        },
        {
          ...BUTTON_DEFAULT.NEXT, label: 'Continuar', onClick: () => {
            getform_datos_servicio().save({ params: {
              ...getform_datos_servicio().getData(),
              ID_CADENA: pageApi.getParamId()
            } });
            this.props.cambiarTabPanel("3", 0);
          }
        },
      ]
    }

    return (
      <>
        <FormFw
          name="form_datos_servicio"
          getParentApi={pageApi.getApi}
          config={form_datos_servicio}
        />
        <BarButtonFw
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooterdatos_servicio}
        />
      </>
    );
  }
}
export default DatosServisiosModal